<template>
  <div class="voucher">
    <success-fade-alert ref="alert" :msg="alert.success" />
    <b-card>
      <b-row>
        <b-col cols="2">
          <b-form-group label-for="type" label="Tipo">
            <b-form-checkbox
              id="isFill"
              v-model="newVoucher.fill"
              :value="true"
              :unchecked-value="false"
              @input="isFill()"
            >
              Preenchimento
            </b-form-checkbox>
            <b-form-checkbox
              class="mt-2"
              id="isVehicle"
              v-model="newVoucher.vehicle"
              :value="true"
              :unchecked-value="false"
              @input="isVehicle()"
            >
              Veículos
            </b-form-checkbox>
            <b-form-checkbox
              class="mt-2"
              id="isDiscount"
              v-model="newVoucher.discount"
              :value="true"
              :unchecked-value="false"
              @input="isDiscount()"
            >
              Desconto
            </b-form-checkbox>
            <b-form-checkbox
              class="mt-2"
              id="isBonus"
              v-model="newVoucher.bonus"
              :value="true"
              :unchecked-value="false"
              @input="isDiscount()"
            >
              Bônus
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-row>
            <b-col>
              <b-form-group label-for="amount" :label="getAmoutLabel">
                <b-form-input
                  v-model="newVoucher.amount"
                  type="number"
                  id="name"
                  v-mask="'999999999999999'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="amount" label="Validade (Meses)">
                <b-form-input
                  v-model="newVoucher.validity"
                  type="number"
                  id="name"
                  v-mask="'999999999999999'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="2" v-if="newVoucher.bonus">
          <b-row>
            <b-col>
              <b-form-group label-for="bonus" label="Valor do bônus">
                <b-form-input
                  v-model="newVoucher.bonusValue"
                  type="text"
                  id="name"
                  v-mask="'money'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="bonus" label="Beneficiado">
                <b-form-input
                  v-model="newVoucher.bonusName"
                  type="text"
                  id="name" 
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="2">
          <b-row>
            <b-col>
              <b-form-group
                label-for="expirationDate"
                label="Data de expiração"
              >
                <b-form-input
                  v-model="newVoucher.expirationDate"
                  type="date"
                  id="name"
                  v-mask="'dd/MM/yyyy'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="amountUsed" label="Quantidade">
                <b-form-input
                  v-model="newVoucher.amountUsed"
                  type="number"
                  id="name"
                  v-mask="'999999999999999'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="1">
          <b-button size="sm" @click="gerateCode()" class="mt-4"
            >Gerar</b-button
          >
        </b-col>
        <b-col cols="3">
          <b-form-group label="Código" label-for="code">
            <b-form-input
              v-model="newVoucher.code"
              type="text"
              id="code"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-button class="file" @click="copyCode()"
                ><b-icon icon="files" aria-hidden="true"></b-icon
              ></b-button>
            </b-input-group-append>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "VoucherCrud",
  directives: {
    mask: AwesomeMask,
  },
  components: {
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Código copiado com sucesso",
      },
      newVoucher: {
        code: "",
        expirationDate: "",
        fill: false,
        vehicle: false,
        discount: false,
        bonus: false,
        amount: 0,
        validity: 0,
        bonusValue: "",
        bonusName: "",
      },
    };
  },
  computed: {
    getAmoutLabel() {
      if (this.newVoucher.fill) {
        return "Quantidade de preenchimento";
      } else if (this.newVoucher.vehicle) {
        return "Quatidade de veículo";
      } else if (this.newVoucher.discount) {
        return "Porcentagem de desconto";
      }
      return "Valor";
    },
  },
  methods: {
    gerateCode() {
      this.$apiScheduler
        .post("/voucher/create/", this.newVoucher)
        .then((data) => {
          this.newVoucher = data.data;
          this.$emit("refresh-table");
          this.$forceUpdate();
        });
    },
    copyCode() {
      navigator.clipboard
        .writeText(this.newVoucher.code)
        .then(() => {
          this.$refs.alert.show();
        })
        .catch((err) => {
          console.error("Erro ao copiar: ", err);
        });
    },
    isVehicle() {
      if (this.newVoucher.vehicle) {
        this.newVoucher.fill = false;
        this.newVoucher.discount = false;
      }
    },
    isFill() {
      if (this.newVoucher.fill) {
        this.newVoucher.vehicle = false;
        this.newVoucher.discount = false;
      }
    },
    isDiscount() {
      if (this.newVoucher.discount) {
        this.newVoucher.fill = false;
        this.newVoucher.vehicle = false;
      }
    },
  },
  mounted() {
    // Code to run when the component is mounted
  },
};
</script>

<style scoped>
.file {
  position: absolute;
  width: 20%;
  height: 62%;
  margin-left: 85%;
  margin-top: -38px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>